import { Stack, Box } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { useOutletContext, useSearchParams } from 'react-router-dom'
import { SelectedVideoCard } from '../components/SelectedVideoCard'
import { VideosContainer } from '../components/VideosContainer'
import { IVideo, useFetchVideos } from '../hooks/useFetchVideos'
import { LoadMoreBtn } from '../../../../components/Loader'

export function VideoXGC() {
  const [searchParams, setSearchParams] = useSearchParams()
  // @ts-ignore
  const [,,, setCount] = useOutletContext();
  const [videoId, setVideoId] = useState<number | null>(null)
  const { loading, videos, error, fetchVideos, total, loadMore } = useFetchVideos('XGC')

  useEffect(() => {
    const video = searchParams.get('video')
    if (video) {
      const id = parseInt(video, 10) || 0;
      if (id) setVideoId(id);  
    }
  }, [searchParams])

  useEffect(() => {
    if (total) setCount(total);
  }, [total]);

  const handleSelectVideo = (video: IVideo) => {
    setVideoId(video.id)
    //updateVideoId(video.id)
  }

  const handleResetVideo = () => {
    searchParams.delete('selectedTab')
    setSearchParams()
    setVideoId(null)
    //updateVideoId(null)
  }

  return (
    <Stack direction="row" alignItems="top">
      {videoId !== null ? (
        <Box flexGrow={1}>
          <SelectedVideoCard videoId={videoId} onClose={() => handleResetVideo()} type="file" refetch={fetchVideos} />
        </Box>
      ) : (
        <Box
          height={videoId !== null ? '77vh' : 'auto'}
          maxWidth={videoId !== null ? '50%' : 'auto'}
          flexGrow={1}
          sx={{
            overflow: 'visible',
            paddingRight: '16px',
            marginRight: '16px',
          }}
        >
          <Box
            sx={{
              overflow: 'visible',
              marginRight: '-30px',
            }}
          >
            <VideosContainer loading={loading} error={error} videos={videos} onSelectVideo={handleSelectVideo} selectedVideoId={videoId} />
          </Box>
          {Array.isArray(videos) && videos.length < total && (
            <LoadMoreBtn onClick={loadMore} loading={loading} />
          )}
        </Box>
      )}
    </Stack>
  )
}
